/**
 * FN-FE-SUB-04 — Full-page Locked Screen
 */
import { useNavigate } from 'react-router-dom';

interface Props {
  daysUntilPurge: number;
}

export default function LockedScreen({ daysUntilPurge }: Props) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8 bg-gray-50">
      <div className="text-8xl text-gray-300 mb-6">🔒</div>
      <h1 className="text-3xl font-bold text-[#14233F]">Az előfizetésed le van zárva</h1>
      <p className="text-gray-700 mt-3 text-center max-w-md">
        Az adataidat még <strong>{daysUntilPurge} napig</strong> megőrizzük.
        Frissítsd az előfizetésedet, hogy újra hozzáférj.
      </p>
      <button
        onClick={() => navigate('/beallitasok/szamlazas')}
        className="mt-6 px-8 py-3 text-lg bg-[#F47B20] text-white font-semibold rounded-lg hover:bg-[#e06b15]"
      >
        Előfizetés-kezelés
      </button>
      <button className="mt-3 text-gray-500 hover:text-gray-700 underline text-sm">
        Adataim letöltése
      </button>
      <p className="mt-8 text-xs text-gray-400 max-w-sm text-center">
        A NAV-bejelentett számlák a törlés után is megőrződnek 8 évig a jogszabályi kötelezettség szerint.
      </p>
    </div>
  );
}
